import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ArticleService, PublicArticle } from '../services/article.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})
export class BlogComponent implements OnInit {
  articles: PublicArticle[] = [];
  categories: string[] = [];
  selectedCategory = '';

  page = 1;
  totalPages = 1;
  readonly pageSize = 9;

  loading = true;
  loadingMore = false;
  error = false;

  readonly skeletons = [1, 2, 3, 4, 5, 6];

  constructor(public articleService: ArticleService, private title: Title) {}

  ngOnInit(): void {
    this.title.setTitle('Blog · East Indonesia Trip');
    this.loadCategories();
    this.load(true);
  }

  selectCategory(category: string): void {
    if (this.selectedCategory === category) return;
    this.selectedCategory = category;
    this.load(true);
  }

  loadMore(): void {
    if (this.page >= this.totalPages || this.loadingMore) return;
    this.page += 1;
    this.load(false);
  }

  trackById(_: number, article: PublicArticle): number {
    return article.id;
  }

  load(reset: boolean): void {
    if (reset) {
      this.page = 1;
      this.loading = true;
    } else {
      this.loadingMore = true;
    }
    this.error = false;

    this.articleService.getPublished({ page: this.page, limit: this.pageSize, category: this.selectedCategory }).subscribe({
      next: (res) => {
        const items = res?.data ?? [];
        this.articles = reset ? items : [...this.articles, ...items];
        this.totalPages = res?.meta?.total_pages || 1;
        this.loading = false;
        this.loadingMore = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
        this.loadingMore = false;
      }
    });
  }

  // Categories come from the latest published articles
  private loadCategories(): void {
    this.articleService.getPublished({ limit: 50 }).subscribe({
      next: (res) => {
        const names = (res?.data ?? []).map(a => (a.category || '').trim()).filter(Boolean);
        this.categories = Array.from(new Set(names)).sort();
      },
      error: () => (this.categories = [])
    });
  }
}
